// extracted by mini-css-extract-plugin
export default {"upgrade":"OsRTv80k","badgeNew":"SeIl6ODU"};